import { setUser } from '@sentry/react';
import { useStatsigClient } from '@statsig/react-bindings';
import { useEffect } from 'react';
import { useAccount } from 'wagmi';
import { tryCatch } from '../../lib/tryCatch';

export const UserTracker = () => {
  const { address, isConnected, connector } = useAccount();
  const { client } = useStatsigClient();

  useEffect(() => {
    if (isConnected && address) {
      setUser({
        id: address,
        walletAddress: address,
        connectorName: connector?.name || connector?.id || 'unknown',
      });
      tryCatch(() => client.updateUserSync({ userID: address }));
    } else {
      setUser(null);
    }
  }, [address, client, connector?.id, connector?.name, isConnected]);

  return null;
};
